namespace TabAurous.HR {
    export interface EmployeeQualificationForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
    }

    export class EmployeeQualificationForm extends Serenity.PrefixedContext {
        static formKey = 'HR.EmployeeQualification';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmployeeQualificationForm.init)  {
                EmployeeQualificationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(EmployeeQualificationForm, [
                    'Code', w0,
                    'Name', w0
                ]);
            }
        }
    }
}
